<template>
    <div id="menu">
        <hsc-menu-style-black style="margin: 0px; border-radius: 0px;">
            <hsc-menu-bar style="width: 100%; margin: 0px; padding: 0px;  background-color: #444 !important;">
                <hsc-menu-bar-item label="Archivo" style="">
                    <hsc-menu-item label="Nuevo"                                                      @click="emitEvent('editor.new', false)" />
                    <hsc-menu-item label="Abrir..."                                                   @click="emitEvent('editor.open.dialog', false)" />
                    <hsc-menu-item :disabled="disableNonCodeEditorMenu" label="Guardar código..."     @click="emitEvent('editor.downloadCode', true)" />
                    <hsc-menu-item :disabled="disableNonCodeEditorMenu" label="Guardar pantalla..."   @click="emitEvent('editor.downloadScreen', true)" />
                    <hsc-menu-item v-show="showExit"                    label="Salir"                 @click="exitApp()" />
                </hsc-menu-bar-item>
                <hsc-menu-bar-item label="Código">
                    <hsc-menu-item :disabled="disableNonCodeEditorMenu" label="Ejecutar"              @click="emitEvent('editor.execute', true)" />
                    <hsc-menu-item :disabled="disableNonCodeEditorMenu" label="Parar"                 @click="emitEvent('editor.stopExecution', true)" />
                    <hsc-menu-separator/>
                    <hsc-menu-item :disabled="disableNonCodeEditorMenu" label="Agrandar fuente"       @click="emitEvent('editor.fontSizeUp', false)" />
                    <hsc-menu-item :disabled="disableNonCodeEditorMenu" label="Achicar fuente"        @click="emitEvent('editor.fontSizeDown', false)" />
                </hsc-menu-bar-item>
                <hsc-menu-bar-item label="Pantalla">
                    <hsc-menu-item :disabled="disableNonCodeEditorMenu" label="Mostrar/Ocultar panel" @click="emitEvent('screen.toggle', true)" />
                    <hsc-menu-item :disabled="disableNonCodeEditorMenu" label="Limpiar"               @click="emitEvent('screen.clear', true)" />
                    <hsc-menu-item :disabled="disableNonCodeEditorMenu" label="Pantalla completa"     @click="emitEvent('screen.fullscreen', true)" />
                    <hsc-menu-item :disabled="disableNonCodeEditorMenu" label="Agrandar fuente"       @click="emitEvent('screen.fontSizeUp', false)" />
                    <hsc-menu-item :disabled="disableNonCodeEditorMenu" label="Achicar fuente"        @click="emitEvent('screen.fontSizeDown', false)" />
                </hsc-menu-bar-item>
                <hsc-menu-bar-item label="Inspector">
                    <hsc-menu-item :disabled="disableNonCodeEditorMenu" label="Mostrar/Ocultar panel" @click="emitEvent('inspector.toggle', true)" />
                    <hsc-menu-item :disabled="disableNonCodeEditorMenu" label="Limpiar tabla"         @click="emitEvent('inspector.clear', true)" />
                </hsc-menu-bar-item>
                <hsc-menu-bar-item v-show="showVirtualMachine" label="Máquina Virtual">
                    <hsc-menu-item :disabled="disableNonCodeEditorMenu" label="Mostrar/Ocultar Inspector" @click="emitEvent('vm.inspector.toggle', true)" />
                </hsc-menu-bar-item>
                <hsc-menu-bar-item label="Opciones">
                    <hsc-menu-item label="Configuracion"                                              @click="emitEvent('options.config', false)" />
                    <hsc-menu-item label="Acerca de..."                                               @click="emitEvent('help.about', false)" />
                </hsc-menu-bar-item>
                <hsc-menu-bar-item v-show="showDownloads" label="Versión Escritorio">
                    <hsc-menu-item v-for="download in downloads" :key="download.key" v-bind:label="download.label"         @click="open(download.link)" />
                </hsc-menu-bar-item>
                <hsc-menu-bar-item v-show="false" label="Ayuda">
                    <hsc-menu-item label="Referencia del lenguaje"                                    @click="emitEvent('help.language', false)" />
                </hsc-menu-bar-item>
            </hsc-menu-bar>
        </hsc-menu-style-black>
    </div>
</template>

<script>
    import { EventBus } from './../../EventBus.js'
    import { Storage } from './../../Storage.js'

    export default {
        name: 'Menu',
        created () {
            this.showExit = window.__psflex_platform_type === 'desktop'
            this.showDownloads = window.__psflex_platform_type === 'web'

            this.activeTab = Storage.getActiveTab()
            Storage.onActiveTabChange(activeTab => {
                this.activeTab = activeTab
                if (activeTab === null) {
                    this.disableNonCodeEditorMenu = true
                } else {
                    this.disableNonCodeEditorMenu = activeTab.type !== 'CodeEditor'
                }
            })
            this.downloads = window.__downloads || []
        },
        methods: {
            emitEvent (eventName, isForCurrentTab) {
                this.emitEventWithPayload(eventName, isForCurrentTab, null)
            },
            emitEventWithPayload (eventName, isForCurrentTab, payload) {
                if (isForCurrentTab && this.activeTab !== null) {
                    EventBus.$emit(eventName + '.' + this.activeTab.id, payload)
                } else {
                    EventBus.$emit(eventName, payload)
                }
            },
            exitApp () {
                if (window.__exit_func !== undefined) {
                    window.__exit_func()
                }
            },
            open (url) {
                window.open(url)
            }
        },
        data () {
            return {
                disableNonCodeEditorMenu: false,
                activeTab: null,
                showExit: false,
                showVirtualMachine: process.env.NODE_ENV === 'development'
            }
        }
    }
</script>

<style>
    .menubar * {
        border-radius: 0px !important;
        z-index: 999999 !important;
    }
    .menu {
        background-color: #444 !important;
    }
</style>


// WEBPACK FOOTER //
// src/Components/Menu/Menu.vue